import ChallengeCard from 'components/ChallengeCard';
import ChallengeCardV2 from 'components/ChallengeCardV2';
import ChaseCard from 'components/Chase/ChaseCard';
import ChaseMenu from 'components/Chase/ChaseMenu';
import { Empty, Loading } from 'components/LottieFiles';
import Title from 'components/Typography/Title';
import ChevronLeft from 'Icons/ChevronLeft';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useData from 'store/useData';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  BackButton,
  ChaseContent,
  ChaseHeader,
  ChaseNav,
  ContentCard,
  ContentSwipe,
  Wrapper,
} from './Chase.styles';
import NoImage from 'assets/images/noImage.png';
import { ChaseMenuItems } from 'config/Chase';
import useSound from 'use-sound';
import ClickSound from 'assets/sounds/Tap.wav';
import useMission from 'store/useMission';
import useUser from 'store/useUser';

const Chase = () => {
  const [playClick] = useSound(ClickSound);
  const { t } = useTranslation();
  const { missions, objects } = useData();
  const { isLogged } = useUser();
  const navigate = useNavigate();
  const [menu, setMenu] = useState<string>('quests');
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setChaseData] = useState<any>([]);
  const [randomNumber] = useState<number>(
    Math.floor(Math.random() * data?.length) || 0,
  );
  const { onGoing, setSelectedQuest, setMission, setObject, setRefresh } =
    useMission();
  const goBack = () => {
    playClick();
    navigate(-1);
  };

  // get data by menu
  const getDataByMenu = (menu: string) => {
    switch (menu) {
      case 'objects':
        return objects;
      case 'missions':
        return missions;
      case 'quests':
        return test;
      default:
        return objects;
    }
  };

  useEffect(() => {
    if (!isLogged) navigate('/start');
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    onGoing && navigate('/map');
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLoading(true);
    const data = getDataByMenu(menu);
    setChaseData(data);
    setLoading(false);
    // eslint-disable-next-line
  }, [menu]);

  const onStart = async (item: any) => {
    switch (menu) {
      case 'objects':
        setObject(item);
        break;
      case 'missions':
        setMission(item);
        break;
      case 'quests':
        setSelectedQuest(item);
        setMission(item.missions[0]);
        break;
      default:
        break;
    }

    setRefresh(true);
    navigate('/map');
  };

  return (
    <Wrapper>
      <ChaseHeader>
        <ChaseNav>
          <BackButton onClick={goBack}>
            <ChevronLeft width="17" height="23" />
          </BackButton>
          <Title level={1} renderAs="label">
            {t('todaychase')}
          </Title>
        </ChaseNav>
        {loading ? (
          <Loading />
        ) : data && data[0] && !loading ? (
          <ChaseCard
            borderRadius="0.875rem"
            coins={data[0].coins ? data[0].coins + '' : '0'}
            distance={
              menu === 'quests'
                ? data[0]?.missions && data[0]?.missions[0]?.distance
                : data[0].distance
            }
            imageSrc={data[0].imageSrc || NoImage}
            mode={t(data[0].level)}
            onClick={() => {}}
            shadowColor="#007AD1"
            title={data[0].name}
            avatarName={data[0].avatarName}
            height="13.188rem"
            onStart={() => onStart(data[0])}
            width="100%"
          />
        ) : (
          <Empty />
        )}
        <ChaseMenu items={ChaseMenuItems} setMenu={setMenu} />
      </ChaseHeader>
      <ChaseContent>
        <Title level={1} renderAs="label">
          {t('PopularChallenges')}
        </Title>
        <ContentSwipe>
          {loading ? (
            <Loading />
          ) : data && data[0] ? (
            <Swiper slidesPerView="auto" spaceBetween={30}>
              {data &&
                data.map((item: any, index: number) => {
                  return (
                    <SwiperSlide key={index}>
                      <ChallengeCard
                        borderRadius="0.875rem"
                        coins={item.coins ? item.coins + '' : '0'}
                        distance={
                          menu === 'quests'
                            ? item?.missions && item?.missions[0]?.distance
                            : item.distance
                        }
                        imageSrc={item.imageSrc || NoImage}
                        mode={t(item.level)}
                        onClick={() => onStart(item)}
                        shadowColor="#007AD1"
                        title={
                          item.name.length > 20
                            ? item.name.slice(0, 20) + '...'
                            : item.name
                        }
                        variant={index % 2 === 0 ? 'small' : 'large'}
                      />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          ) : (
            <Empty />
          )}
        </ContentSwipe>
        {data && data[0] && (
          <ContentCard>
            <ChallengeCardV2
              borderRadius="0.875rem"
              coins={
                data[randomNumber].coins ? data[randomNumber].coins + '' : '0'
              }
              distance={
                menu === 'quests'
                  ? data[randomNumber]?.missions &&
                    data[randomNumber]?.missions[0]?.distance
                  : data[randomNumber].distance || '0km'
              }
              imageSrc={data[randomNumber].imageSrc || NoImage}
              onClick={() => onStart(data[randomNumber])}
              shadowColor="#007AD1"
              title={
                data[randomNumber].name.length > 25
                  ? data[randomNumber].name.slice(0, 25) + '...'
                  : data[randomNumber].name
              }
            />
          </ContentCard>
        )}
      </ChaseContent>
    </Wrapper>
  );
};

export default Chase;
